<template>
  <span :class="claseCompleta">
    {{ montoFormateado }}
  </span>
</template>

<script setup>
import { computed } from 'vue'
import { useFormatoMoneda } from '@/composables/finanzas/useFormatoMoneda'

const props = defineProps({
  monto: {
    type: [Number, String],
    default: 0
  },
  moneda: {
    type: String,
    default: 'MXN'
  },
  size: {
    type: String,
    default: 'base', // xs, sm, base, lg, xl
    validator: (value) => ['xs', 'sm', 'base', 'lg', 'xl'].includes(value)
  },
  colorAutomatico: {
    type: Boolean,
    default: true
  },
  colorFijo: {
    type: String,
    default: null
  },
  bold: {
    type: Boolean,
    default: false
  }
})

const { formatearMoneda, obtenerClaseColor } = useFormatoMoneda()

const montoFormateado = computed(() => {
  return formatearMoneda(props.monto, props.moneda)
})

const claseCompleta = computed(() => {
  const clases = []

  // Tamaño
  const tamanos = {
    xs: 'text-xs',
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
    xl: 'text-xl'
  }
  clases.push(tamanos[props.size] || tamanos.base)

  // Peso
  if (props.bold) {
    clases.push('font-bold')
  } else {
    clases.push('font-medium')
  }

  // Color
  if (props.colorFijo) {
    clases.push(props.colorFijo)
  } else if (props.colorAutomatico) {
    clases.push(obtenerClaseColor(props.monto))
  } else {
    clases.push('text-gray-900 dark:text-gray-100')
  }

  return clases.join(' ')
})
</script>
